import Textarea from './Textarea';
import type { IProps as ITextareaProps } from './Textarea';

export { Textarea };
export type { ITextareaProps };

export default Textarea;
